class BackInStock {
  constructor() {
    // Seleziona tutti i pulsanti di notifica
    this.buttons = document.querySelectorAll('.back-in-stock-button, .back-in-stock-bell');
    
    // Controlla se c'è una richiesta pendente dopo login
    this.checkPendingRequest();
    
    // Aggiorna lo stato iniziale dei pulsanti in base ai metafield
    this.updateInitialButtonsState();
    
    // Inizializza i listener
    this.init();
    
    console.log('BackInStock inizializzato, trovati', this.buttons.length, 'pulsanti');
  }
  
  // Modifica il metodo updateInitialButtonsState
  updateInitialButtonsState() {
    // Verifica se abbiamo i dati cliente
    if (window.customerData) {
      console.log('Dati cliente disponibili, controllo alert...', window.customerData.productAlerts);
      
      // Assicurati che productAlerts sia un array
      let productAlerts = window.customerData.productAlerts;
      
      // Se productAlerts è undefined, prova a recuperare i dati direttamente
      if (productAlerts === undefined || productAlerts === null || window.needDirectMetafieldAccess) {
        console.log('Alert non trovati nei dati cliente o flag per accesso diretto attivo, avvio recupero alternativo');
        this.fetchProductAlertsDirectly();
        return; // Uscita anticipata dal metodo
      }
      
      // Gestione dell'errore specifico
      if (productAlerts && productAlerts.error === 'json not allowed for this object') {
        console.log('Rilevato errore di conversione JSON, utilizzo API alternativa');
        this.fetchProductAlertsDirectly();
        return; // Uscita anticipata dal metodo
      }
      
      if (typeof productAlerts === 'string') {
        try {
          productAlerts = JSON.parse(productAlerts);
        } catch (e) {
          // Se non è un JSON valido, potrebbe essere una stringa separata da virgole
          productAlerts = productAlerts.split(',').map(id => id.trim());
        }
      }
      
      if (!Array.isArray(productAlerts)) {
        productAlerts = [];
      }
      
      // Aggiorna il riferimento all'array per utilizzi futuri
      window.customerData.productAlerts = productAlerts;
      
      // Se l'array contiene elementi, aggiorna i pulsanti
      if (productAlerts.length > 0) {
        console.log('Alert trovati nei dati cliente, aggiorno pulsanti', productAlerts);
        this.updateButtonsFromAlertList(productAlerts);
      } else {
        console.log('Nessun alert trovato nei dati cliente');
        
        // Verifica se abbiamo bisogno di recuperare i dati via API
        if (window.needDirectMetafieldAccess) {
          this.fetchProductAlertsDirectly();
        }
      }
    } else {
      console.log('Nessun dato cliente disponibile');
      
      // Fallback al localStorage
      this.checkLocalStorageAlerts();
    }
  }
  
  // Aggiungi questo nuovo metodo per gestire l'errore specifico
  async fetchProductAlertsDirectly() {
    try {
      console.log('Tentativo di recupero diretto degli alert');
      
      // Utilizziamo localStorage come prima fonte
      const storedAlerts = localStorage.getItem('backInStock_alerts');
      if (storedAlerts) {
        try {
          const alertsList = JSON.parse(storedAlerts);
          if (Array.isArray(alertsList) && alertsList.length > 0) {
            console.log('Alert trovati in localStorage:', alertsList);
            
            // Usa questi alert per aggiornare i pulsanti
            this.updateButtonsFromAlertList(alertsList);
            
            // Aggiorna anche window.customerData
            if (window.customerData) {
              window.customerData.productAlerts = alertsList;
            }
            
            return; // Esci dal metodo se abbiamo trovato alert nel localStorage
          }
        } catch (e) {
          console.error('Errore nel parsing degli alert dal localStorage:', e);
        }
      }
      
      // Se non abbiamo nulla nel localStorage, tentiamo una chiamata API diretta
      const customerId = window.customerData?.id;
      if (!customerId) {
        console.log('ID cliente non disponibile, impossibile recuperare gli alert');
        return;
      }
      
      console.log(`Recupero alert per cliente ${customerId} via API`);
      
      // Tenta di recuperare gli alert tramite API
      const response = await fetch(`https://back-in-stock-api.onrender.com/get-alerts?customer_id=${customerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Risposta API get-alerts:', data);
      
      if (data.success && Array.isArray(data.alerts)) {
        console.log('Alert recuperati via API:', data.alerts);
        
        // Aggiorna i pulsanti con gli alert recuperati
        this.updateButtonsFromAlertList(data.alerts);
        
        // Aggiorna anche window.customerData e localStorage per future visite
        if (window.customerData) {
          window.customerData.productAlerts = data.alerts;
        }
        
        localStorage.setItem('backInStock_alerts', JSON.stringify(data.alerts));
      } else {
        console.log('Nessun alert trovato o errore nel recupero');
      }
    } catch (error) {
      console.error('Errore nel recupero diretto degli alert:', error);
      
      // Fallback finale al localStorage
      this.checkLocalStorageAlerts();
    }
  }
  
  // Aggiungi questo metodo di utilità per controllare il localStorage
  checkLocalStorageAlerts() {
    try {
      const storedAlerts = localStorage.getItem('backInStock_alerts');
      if (storedAlerts) {
        const alertsArray = JSON.parse(storedAlerts);
        console.log('Alert trovati in localStorage:', alertsArray);
        
        if (Array.isArray(alertsArray) && alertsArray.length > 0) {
          // Aggiorna i pulsanti con gli alert dal localStorage
          this.updateButtonsFromAlertList(alertsArray);
        }
      }
    } catch (e) {
      console.error('Errore nel recupero degli alert dal localStorage:', e);
    }
  }
  
  // Aggiungi questo metodo per centralizzare l'aggiornamento dei pulsanti
  updateButtonsFromAlertList(alertsList) {
    if (!Array.isArray(alertsList) || alertsList.length === 0) {
      console.log('Nessun alert da elaborare');
      return;
    }
    
    console.log('Aggiornamento pulsanti da lista alert:', alertsList);
    
    // Per ogni pulsante, verifica se il prodotto è nell'elenco alert
    this.buttons.forEach(button => {
      const productId = button.dataset.productId;
      
      if (productId && alertsList.includes(String(productId))) {
        console.log('Prodotto', productId, 'trovato negli alert, aggiorno il pulsante');
        
        // Aggiorna l'aspetto del pulsante
        const isBell = button.classList.contains('back-in-stock-bell');
        button.classList.add('active');
        
        if (!isBell) {
          button.innerHTML = `
            <span>${window.theme?.strings?.back_in_stock_remove_notification || 'Sarai notificato quando il prodotto sarà disponibile'}</span>
            <span style="display: inline-block; margin-left: 5px; width: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#d33458">
                <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z"/>
                <!-- Linea diagonale (barra) -->
                <path d="M240-680L720-200" stroke="#000" stroke-width="40" />
              </svg>
            </span>
          `;        
        } else {
          // Aggiungi l'indicatore di notifica attiva se non c'è già
          const indicator = button.querySelector('.notification-active-indicator');
          if (!indicator) {
            const iconContainer = button.querySelector('.icon-container');
            if (iconContainer) {
              const newIndicator = document.createElement('span');
              newIndicator.className = 'notification-active-indicator';
              newIndicator.style.cssText = 'position: absolute; top: -2px; right: -2px; width: 8px; height: 8px; background-color: #e22120; border-radius: 50%;';
              iconContainer.appendChild(newIndicator);
            }
          }
        }
      }
    });
  }
  
  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick.bind(this));
    });
    
    // Listener per il popup di login
    document.addEventListener('shopify:customer_login', this.handleCustomerLogin.bind(this));
  }
  
  handleButtonClick(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const productId = button.dataset.productId;
    const action = button.dataset.action;
    
    console.log('Pulsante cliccato:', { productId, action });
    
    this.toggleAlert(productId, button);
  }
  
  async toggleAlert(productId, buttonElement) {
    try {
      // Ottieni le informazioni del cliente
      const customerId = window.customerData?.id || window.Shopify?.customer?.id;
      const customerEmail = window.customerData?.email || window.Shopify?.customer?.email;
      
      console.log('Info cliente:', { 
        customerId, 
        customerEmail,
        isLoggedIn: !!customerId || !!customerEmail,
        source: window.customerData ? 'Liquid template' : (window.Shopify?.customer ? 'Shopify API' : 'Non identificato')
      });
      
      if (!customerId && !customerEmail) {
        console.log('Cliente non identificato, mostra login');
        this.showLoginModal(productId);
        return;
      }
      
      // Modifica il pulsante per indicare il caricamento
      const originalText = buttonElement?.innerText || '';
      const isBell = buttonElement?.classList.contains('back-in-stock-bell') || false;
      
      if (buttonElement && !isBell) {
        buttonElement.textContent = 'Elaborazione...';
        buttonElement.disabled = true;
      }
      
      // Verifica se l'utente è già iscritto a questo prodotto
      // Assicurati che productAlerts sia sempre un array
      const productAlerts = window.customerData?.productAlerts || [];
      const isSubscribed = Array.isArray(productAlerts) && productAlerts.includes(String(productId));
      
      console.log('Stato iscrizione attuale:', isSubscribed, 'Array alerts:', productAlerts);
      
      // Prepara i dati per la richiesta
      const requestData = { 
        product_id: productId,
        customer_id: customerId,
        customer_email: customerEmail
      };
      
      // Se sappiamo già lo stato, includiamolo
      if (typeof isSubscribed === 'boolean') {
        requestData.action = isSubscribed ? 'unsubscribe' : 'subscribe';
      }
      
      console.log('Invio richiesta al server:', requestData);
      
      const response = await fetch('https://back-in-stock-api.onrender.com/toggle-alert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });
      
      // Verifica se la risposta è OK prima di interpretarla come JSON
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        this.updateButtonsState(productId, data.subscribed);
        
        // Aggiorna anche la lista locale di notifiche
        if (window.customerData) {
          // Assicurati che productAlerts sia sempre un array
          if (!window.customerData.productAlerts) {
            window.customerData.productAlerts = [];
          }
          
          if (data.subscribed) {
            if (!window.customerData.productAlerts.includes(String(productId))) {
              window.customerData.productAlerts.push(String(productId));
            }
          } else {
            window.customerData.productAlerts = window.customerData.productAlerts.filter(id => id !== String(productId));
          }
        }
      } else {
        console.error('Errore nella gestione dell\'alert:', data.error);
        if (buttonElement && !isBell) {
          buttonElement.textContent = originalText || 'Avvisami quando disponibile';
          buttonElement.disabled = false;
        }
      }
    } catch (error) {
      console.error('Errore nella richiesta:', error);
      
      // Ripristina lo stato del pulsante
      if (buttonElement) {
        const isBell = buttonElement.classList.contains('back-in-stock-bell');
        if (!isBell) {
          buttonElement.textContent = 'Errore, riprova';
          buttonElement.disabled = false;
        }
      }
      
      // Per debugging, tenta comunque di aggiornare localmente lo stato dei pulsanti
      try {
        // Inverti lo stato attuale come fallback
        const currentState = buttonElement?.classList.contains('active') || false;
        this.updateButtonsState(productId, !currentState);
      } catch (e) {
        console.error('Impossibile aggiornare lo stato dei pulsanti:', e);
      }
    }
  }
  
  updateButtonsState(productId, isSubscribed) {
    console.log('Aggiornamento pulsanti per prodotto', productId, 'stato:', isSubscribed);
    
    // Aggiorna lo stato di tutti i pulsanti per questo prodotto
    const buttons = document.querySelectorAll(`.back-in-stock-button[data-product-id="${productId}"], .back-in-stock-bell[data-product-id="${productId}"]`);
    
    console.log(`Trovati ${buttons.length} pulsanti da aggiornare`);
    
    buttons.forEach(button => {
      const isBell = button.classList.contains('back-in-stock-bell');
      
      if (isSubscribed) {
        button.classList.add('active');
        if (!isBell) {
          button.innerHTML = `
            <span>${window.theme?.strings?.back_in_stock_remove_notification || 'Sarai notificato quando il prodotto sarà disponibile'}</span>
            <span style="display: inline-block; margin-left: 5px; width: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#d33458">
                <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z"/>
                <!-- Linea diagonale (barra) -->
                <path d="M240-680L720-200" stroke="#000" stroke-width="40" />
              </svg>
            </span>
          `;
          console.log('Pulsante testuale aggiornato con traduzione "remove_notification"');
        } else {
          // Aggiungi l'indicatore di notifica attiva
          const indicator = button.querySelector('.notification-active-indicator');
          if (!indicator) {
            const iconContainer = button.querySelector('.icon-container');
            if (iconContainer) {
              const newIndicator = document.createElement('span');
              newIndicator.className = 'notification-active-indicator';
              newIndicator.style.cssText = 'position: absolute; top: -2px; right: -2px; width: 8px; height: 8px; background-color: #e22120; border-radius: 50%;';
              iconContainer.appendChild(newIndicator);
              console.log('Aggiunto indicatore alla campanella');
            }
          }
        }
      } else {
        button.classList.remove('active');
        if (!isBell) {
          button.innerHTML = `
            <span>${window.theme?.strings?.back_in_stock_notify_me || 'Avvisami quando disponibile'}</span>
            <span style="display: inline-block; margin-left: 5px; width: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#d33458">
                <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z"/>
              </svg>
            </span>
          `;
          console.log('Pulsante testuale aggiornato con traduzione "notify_me" e icona normale');
        } else {
          // Rimuovi l'indicatore di notifica attiva
          const indicator = button.querySelector('.notification-active-indicator');
          if (indicator) {
            indicator.remove();
            console.log('Rimosso indicatore dalla campanella');
          }
        }
      }
      
      button.disabled = false;
    });
    
    // Aggiorna anche window.customerData se disponibile
    if (window.customerData) {
      const productIdStr = String(productId);
      const currentAlerts = Array.isArray(window.customerData.productAlerts) 
        ? window.customerData.productAlerts 
        : [];
      
      if (isSubscribed) {
        // Aggiungi l'ID solo se non è già presente
        if (!currentAlerts.includes(productIdStr)) {
          const newAlerts = [...currentAlerts, productIdStr];
          window.customerData.productAlerts = newAlerts;
          console.log('Aggiornato customerData.productAlerts aggiungendo:', productIdStr);
          console.log('Nuovo stato:', newAlerts);
        }
      } else {
        // Rimuovi l'ID se presente
        const newAlerts = currentAlerts.filter(id => id !== productIdStr);
        window.customerData.productAlerts = newAlerts;
        console.log('Aggiornato customerData.productAlerts rimuovendo:', productIdStr);
        console.log('Nuovo stato:', newAlerts);
      }
    }
    
    // Forza un aggiornamento della cache dei metafield per garantire la coerenza alla prossima visita
    this.refreshMetafieldCache(productId, isSubscribed);
  }
  
  // Aggiungi un nuovo metodo per forzare l'aggiornamento della cache
  refreshMetafieldCache(productId, isSubscribed) {
    console.log('Aggiornamento cache metafield per prodotto', productId, 'stato:', isSubscribed);
    
    // Emetti evento per altri componenti
    const event = new CustomEvent('backInStock:stateChanged', { 
      detail: { 
        productId: productId,
        isSubscribed: isSubscribed
      } 
    });
    document.dispatchEvent(event);
    
    console.log('Evento backInStock:stateChanged emesso', {
      productId: productId,
      isSubscribed: isSubscribed
    });
    
    // Salva anche in localStorage come fallback
    try {
      const productIdStr = String(productId);
      
      // Salva lo stato corrente
      localStorage.setItem('backInStock_' + productIdStr, 
        isSubscribed ? 'subscribed' : 'unsubscribed');
      
      // Salva anche nel localStorage come backup
      if (window.customerData && Array.isArray(window.customerData.productAlerts)) {
        localStorage.setItem('backInStock_alerts', 
          JSON.stringify(window.customerData.productAlerts));
      }
    } catch (e) {
      console.error('Errore nel salvataggio del fallback:', e);
    }
  }
  
  showLoginModal(productId) {
    // Salva la richiesta pendente nel sessionStorage
    sessionStorage.setItem('pendingBackInStockRequest', productId);
    
    // Apri il drawer di login
    if (typeof window.openLoginDrawer === 'function') {
      window.openLoginDrawer();
    } else {
      // Fallback se la funzione personalizzata non esiste
      document.dispatchEvent(new Event('openLoginDrawer'));
      
      // Ulteriore fallback se l'evento non viene intercettato
      setTimeout(() => {
        const loginLink = document.querySelector('a[href="/account/login"]');
        if (loginLink) {
          loginLink.click();
        } else {
          window.location.href = '/account/login?redirect_back=true';
        }
      }, 100);
    }
  }
  
  checkPendingRequest() {
    const pendingRequest = sessionStorage.getItem('pendingBackInStockRequest');
    
    if (pendingRequest && (window.customerData?.id || window.Shopify?.customer?.id)) {
      console.log('Richiesta pendente trovata dopo login:', pendingRequest);
      
      // Rimuovi la richiesta pendente
      sessionStorage.removeItem('pendingBackInStockRequest');
      
      // Elabora la richiesta
      this.toggleAlert(pendingRequest);
    }
  }
  
  handleCustomerLogin() {
    console.log('Evento login cliente rilevato');
    this.checkPendingRequest();
  }
}

// Inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM caricato, inizializzazione BackInStock');
  new BackInStock();
});